import { render, staticRenderFns } from "./DynamicDropdown.vue?vue&type=template&id=0b153f11&scoped=true"
import script from "./DynamicDropdown.vue?vue&type=script&lang=js"
export * from "./DynamicDropdown.vue?vue&type=script&lang=js"
import style0 from "./DynamicDropdown.vue?vue&type=style&index=0&id=0b153f11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b153f11",
  null
  
)

export default component.exports